__turbopack_context__.v({
  "video-section": "video-section-component-module-scss-module__09ABDG__video-section",
  "video-section__video": "video-section-component-module-scss-module__09ABDG__video-section__video",
});
